module.exports = __webpack_public_path__ + "img/gebratenenudelnmithintergrund.b9cecf85.jpg";